module.exports = __webpack_public_path__ + "static/media/important-tips-to-know-before-developing-a-mobile-app.3b345f40.svg";